import type { HTMLAttributes, ReactNode } from "react";

interface ListRowProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  leading?: ReactNode;
  title: ReactNode;
  meta?: ReactNode;
  trailing?: ReactNode;
  variant?: "list" | "grid";
}

export function ListRow({ leading, title, meta, trailing, variant = "list", className = "", ...props }: ListRowProps) {
  return (
    <div className={`mmm-list-row mmm-list-row--${variant} ${className}`.trim()} {...props}>
      {leading && <span className="mmm-list-row-leading">{leading}</span>}
      <span className="mmm-list-row-main">
        <span className="mmm-list-row-title">{title}</span>
        {meta && <span className="mmm-list-row-meta">{meta}</span>}
      </span>
      {trailing && <span className="mmm-list-row-trailing">{trailing}</span>}
    </div>
  );
}
